export default {
  computed: {},
  methods: {
    setIntegrationData(integrationData) {
      if (typeof Chatra === 'function') {
        Chatra('setIntegrationData', integrationData); // eslint-disable-line
      }
    },
    hideChatra() {
      if (typeof Chatra === 'function') {
        Chatra('hide');                                // eslint-disable-line
      }
    },
    showChatra() {
      if (typeof Chatra === 'function') {
        Chatra('show');                                // eslint-disable-line
        Chatra('openChat');                            // eslint-disable-line
      }
    },
  },
};
